import React, { Component } from 'react';
import {observer} from 'mobx-react';
import envStore from '../request/model';
import './index.styl';
import Property from './Property';

const clzpre = 'env-digital';

@observer
class Chart extends Component {
    render() {
        const {info} = this.props.envStore;
        return <div className={clzpre}>
            {info.map((d) => <Property data={d} key={d.key} />)}
        </div>
    }
}

export default (props) => <Chart {...props} envStore={envStore} />;